'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styledText = require('../../styled-text');

var _styledText2 = _interopRequireDefault(_styledText);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _ChevronDownIcon = require('../../../icons/ChevronDownIcon');

var _CheckIcon = require('../../../icons/CheckIcon');

require('./assets/dropdown.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var STYLE_BASE = 'zk-drop-down_';

var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnBlur = function (value) {
      var _this$props = _this.props,
          onBlur = _this$props.onBlur,
          input = _this$props.input;

      if (onBlur && value) {
        input ? input.onBlur(value) : onBlur(value);
      }
    }, _this.renderArrow = function (props) {
      var testid = _this.props.testid;
      var innerProps = props.innerProps;
      return _react2.default.createElement('span', _extends({}, innerProps, {
        className: STYLE_BASE + 'arrowContainer',
        'data-testid': testid + '_ARROW'
      }), _react2.default.createElement(_ChevronDownIcon.ChevronDownIcon, {
        height: 16,
        width: 16
      }));
    }, _this.renderInput = function (props) {
      var _this$props2 = _this.props,
          autoComplete = _this$props2.autoComplete,
          field = _this$props2.field,
          testid = _this$props2.testid,
          name = _this$props2.name;
      var inputName = name || (0, _get3.default)(field, 'name', 'zk-select-input');
      return _react2.default.createElement(_reactSelect.components.Input, _extends({}, props, {
        'data-testid': testid,
        autoComplete: autoComplete,
        name: inputName
      }));
    }, _this.renderOption = function (_ref2, index) {
      var label = _ref2.label,
          value = _ref2.value,
          jsxLabel = _ref2.jsxLabel,
          props = _objectWithoutProperties(_ref2, ['label', 'value', 'jsxLabel']);

      var _this$props3 = _this.props,
          selectedValue = _this$props3.selectedValue,
          testid = _this$props3.testid;

      if (selectedValue === value) {
        return _react2.default.createElement(_reactSelect.components.Option, _extends({
          key: '' + value,
          'data-testid': testid + '_' + index,
          className: STYLE_BASE + 'item_selected'
        }, props), jsxLabel || _react2.default.createElement(_styledText2.default, null, label), _react2.default.createElement(_CheckIcon.CheckIcon, null));
      }

      return _react2.default.createElement(_reactSelect.components.Option, _extends({
        key: value + '_' + index,
        'data-testid': testid + '_' + index
      }, props), jsxLabel || _react2.default.createElement(_styledText2.default, null, label));
    }, _this.renderValue = function (_ref3) {
      var label = _ref3.data.label,
          props = _objectWithoutProperties(_ref3, ['data']);

      var innerProps = props.innerProps;
      return _react2.default.createElement(_styledText2.default, _extends({
        numberOfLines: 1
      }, innerProps), label);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dropdown, [{
    key: 'render',
    value: function render() {
      var _classNames,
          _this2 = this;

      var _props = this.props,
          className = _props.className,
          error = _props.error,
          _onChange = _props.onChange,
          onValueChange = _props.onValueChange,
          selectedValue = _props.selectedValue,
          items = _props.items,
          _props$input = _props.input,
          input = _props$input === undefined ? {} : _props$input,
          onBlur = _props.onBlur,
          placeholder = _props.placeholder,
          testid = _props.testid,
          _props$searchable = _props.searchable,
          searchable = _props$searchable === undefined ? false : _props$searchable,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          name = _props.name,
          isMenuOnTop = _props.isMenuOnTop,
          rest = _objectWithoutProperties(_props, ['className', 'error', 'onChange', 'onValueChange', 'selectedValue', 'items', 'input', 'onBlur', 'placeholder', 'testid', 'searchable', 'disabled', 'name', 'isMenuOnTop']); // in v2 package `react-select` uses json object for `value`


      var value = !!selectedValue || selectedValue === 0 ? selectedValue : input.value;
      value = items && items.length && items.find(function (item) {
        return item.value === value;
      });
      return _react2.default.createElement(_reactSelect2.default, _extends({
        className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, STYLE_BASE + 'selectStyleError', error), _defineProperty(_classNames, STYLE_BASE + 'selectStyle', !error), _defineProperty(_classNames, STYLE_BASE + 'menuOnTop', isMenuOnTop), _defineProperty(_classNames, className, !!className), _classNames)),
        classNamePrefix: 'zk-select',
        components: {
          DropdownIndicator: this.renderArrow,
          Input: this.renderInput,
          Option: this.renderOption,
          SingleValue: this.renderValue
        },
        filterOption: (0, _reactSelect.createFilter)({
          matchFrom: 'start'
        }),
        isClearable: false,
        isDisabled: disabled,
        isSearchable: searchable,
        onChange: function onChange(_ref4) {
          var value = _ref4.value;
          var handleChange = onValueChange || _onChange || input.onChange;
          handleChange(value);
        },
        onBlur: function onBlur(value) {
          return _this2.handleOnBlur(input.value || value);
        },
        openMenuOnFocus: true,
        options: items,
        placeholder: placeholder,
        styles: {
          control: function control() {
            return {};
          },
          indicatorsContainer: function indicatorsContainer() {
            return {};
          },
          indicatorSeparator: function indicatorSeparator() {
            return {};
          },
          input: function input() {
            return {};
          },
          menu: function menu() {
            return {};
          },
          menuList: function menuList() {
            return {};
          },
          option: function option() {
            return {};
          },
          placeholder: function placeholder() {
            return {};
          },
          valueContainer: function valueContainer() {
            return {};
          }
        },
        id: testid,
        value: value
      }, rest));
    }
  }]);

  return Dropdown;
}(_react.Component);

Dropdown.propTypes = {
  error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
  isMenuOnTop: _propTypes2.default.bool,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    jsxLabel: _propTypes2.default.object
  })),
  onValueChange: _propTypes2.default.func,
  selectedValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
  disabled: _propTypes2.default.bool,
  testid: _propTypes2.default.string.isRequired
};
exports.default = Dropdown;